import { Tooltip, styled } from "@mui/material";
import { useEffect, useState } from "react";

// Custom Tooltip styling
const StyledTooltip = styled(Tooltip)(({ theme }) => ({
    [`& .MuiTooltip-tooltip`]: {
        backgroundColor: "#4a4a4a",
        color: "#ffffff",
        fontWeight: "bold",
        fontSize: "0.9rem",
        borderRadius: "8px",
        padding: "8px 12px",
    },
    [`& .MuiTooltip-arrow`]: {
        color: "#4a4a4a",
    },
}));

export const RAGStatus = ({deadline}) => {
    const [status, setStatus] = useState("");

    // Function to calculate the difference in days between today and the deadline
    const calculateStatus = (deadline) => {
        const today = new Date();
        const deadlineDate = new Date(deadline);

        // Calculate the difference in time 
        const timeDiff = deadlineDate.getTime() - today.getTime();
        // Convert time difference to days
        const diffDays = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));

        if (diffDays < 0) {
            return "Critical"; // Red: deadline passed
        } else if (diffDays <= 14) {
            return "Warning"; // Amber: Deadline within the next 14 days
        } else {
            return "On-track"; // Green: More than 14 days left
        }
    };

    const setStatusColor = (type) => {
        switch (type) {
            case "Critical":
                return "#DC3545";
            case "Warning":
                return "#FFC107";
            case "On-track":
                return "#28A745";
            default:
                return "#28A745";
        }
    };



    // Update status on deadline change
    useEffect(() => {
        const status = calculateStatus(deadline);
        setStatus(status);
    }, [deadline]);

    return (
        <div className="position-relative" style={{ height: "8px" }}>
            <StyledTooltip title={status} arrow placement="top">
                <div
                    className="rag-circle position-absolute top-0 end-0"
                    style={{
                        height: "10px",
                        width: "10px",
                        backgroundColor: setStatusColor(status),
                        borderRadius: "50%",
                        cursor: "pointer",
                    }}
                ></div>
            </StyledTooltip>
        </div>
    );
};